import { HelpContentConfig, HelpContentEntry } from '../types/help-content'

const DefaultConfig: HelpContentConfig = {
  entries: [
    {
      title: "Configuring Insurance Verification",
      contexts: [
        { app: "scheduler", priority: 10 },
        { app: "settings", context: "insurance-verification-settings", priority: 10 }
      ],
      articleUrl: "https://help.revenuewell.com/hc/en-us/articles/25144574648731-Insurance-Verification-Configuration-Guide",
      featureFlag: "InsuranceVerification2"
    },
    {
      title: "Verification Statues",
      contexts: [
        { app: "scheduler", priority: 10 },
      ],
      articleUrl: "https://help.revenuewell.com/hc/en-us/articles/25153208611227-Insurance-Verification-Manual-Verification-Statuses#4",
      featureFlag: "InsuranceVerification2"
    },
    {
      title: "Manual Insurance Verification",
      contexts: [
        { app: "scheduler", priority: 10 },
      ],
      articleUrl: "https://help.revenuewell.com/hc/en-us/articles/25153208611227-Insurance-Verification-Manual-Verification-Statuses#1",
      featureFlag: "InsuranceVerification2"
    },
    {
      title: "Insurance Verification Best Practices",
      contexts: [
        { app: "scheduler", priority: 10 },
        { app: "settings", context: "insurance-verification-settings", priority: 10 }
      ],
      articleUrl: "https://revenuewell-academy-1.workramp.io/training/019157bb-1009-7b6b-8a1c-be755d59acf2/overview",
      featureFlag: "InsuranceVerification2"
    },
    {
      title: "Overview of Forms",
      contexts: [
        { app: "forms2", priority: 10 },
      ],
      articleUrl: "https://help.revenuewell.com/hc/en-us/articles/29563777071259-Introduction-to-RevenueWell-Forms",
      featureFlag: "Forms2"
    },
    {
      title: "Processing Forms",
      contexts: [
        { app: "forms2", priority: 10 },
      ],
      articleUrl: "https://help.revenuewell.com/hc/en-us/articles/8948985401371-Processing-Forms",
      featureFlag: "Forms2"
    },
    {
      title: "New Forms Tablet Experience",
      contexts: [
        { app: "forms2", priority: 10 },
      ],
      articleUrl: "https://revenuewell-academy-1.workramp.io/training/019257ea-9cc1-7765-8d01-9c317a245603/overview",
      featureFlag: "Forms2"
    },
    {
      title: "Forms in the RevenueWell Academy",
      contexts: [
        { app: "forms2", priority: 10 },
      ],
      articleUrl: "https://revenuewell-academy-1.workramp.io/collections/47593004-70cb-11ed-a029-067360dfb065",
      featureFlag: "Forms2"
    },
  ]
}

export class HelpContentService { 
  private static instance: HelpContentService;
  private config: any
  private helpConfigUrl: string
  private helpContentConfig: HelpContentConfig = DefaultConfig;
  private isLoaded = false;

  private constructor(config: any) {
    this.config = config
    this.helpConfigUrl = this.config.HelpContentConfigUrl 
  }

  public static getInstance(config: any){
    if(HelpContentService.instance) return HelpContentService.instance;
    HelpContentService.instance = new HelpContentService(config);
    return HelpContentService.instance;
  }

  private async loadConfig(){
    if(this.isLoaded || !this.helpConfigUrl) return;

    const res = await fetch(this.helpConfigUrl);
    this.helpContentConfig = await res.json()
    this.isLoaded = true;
  }

  public async getHelpContent(app: string, context: string){
    await this.loadConfig();

    const entries = this.helpContentConfig.entries
      .map<HelpContentEntry>(entry => { 
        //console.log("*** HELP ENTRY:", {app: app, context: context, entry: entry})
        return {
        ...entry,
        contexts: entry.contexts.filter(c => c.app == app && (c.context == context || !c.context))
        } as HelpContentEntry;
      })
      .filter(entry => entry.contexts.length)
      .sort(entry => entry.contexts[0].priority)
    return entries;
  }
  
}
